/**
 * Portrait + background changer locale pack: pt
 */

module.exports = {
  "portrait": {
    "overview": [
      "O Miral AI Background Remover é gratuito após o login e funciona bem para retratos de ombros para cima: fotos do LinkedIn, imagens de currículo, avatares do WeChat ou Instagram e masters transparentes para recortes estilo documento.",
      "Envie um JPG, PNG ou WebP nítido de até 15 MB. A IA detecta a pessoa automaticamente. Antes de baixar, amplie cabelos soltos, óculos, brincos e a linha do colarinho.",
      "Um PNG transparente não é uma foto de documento branca ou azul pronta. Guarde primeiro o master transparente, depois adicione a cor exigida e recorte no tamanho oficial do formulário."
    ],
    "practice": [
      "Começo sempre que posso com o original da câmera. Miniaturas de apps de chat e filtros de beleza pesados amolecem as bordas do cabelo e dificultam manter as hastes dos óculos.",
      "Sempre coloco o recorte em uma tela clara e outra escura. Essa única verificação revela halos pálidos e fios faltando que parecem ok na prévia minúscula."
    ],
    "compareIntro": "Use este guia para pessoas—avatares, fotos estilo documento e headshots profissionais. Use o guia de e-commerce para fundos brancos de produto e o guia de troca de fundo quando quiser uma cena de café ou escritório após o recorte.",
    "workflow": "Envie um retrato claro de até 15 MB, deixe a IA remover o fundo inteiro, inspecione cabelo e óculos e baixe um PNG transparente antes de adicionar branco, azul ou cor da marca.",
    "scenarioIntro": "Escolha o trabalho de retrato mais próximo do seu e inspecione as bordas que costumam falhar nesse caso de uso.",
    "sec": {
      "tldrTitle": "Versão curta",
      "tldrCols": [
        "O que você precisa",
        "Detalhes"
      ],
      "tldrRows": [
        [
          "Preço",
          "O Miral AI Background Remover é gratuito após o login"
        ],
        [
          "Upload",
          "JPG, PNG ou WebP de até 15 MB"
        ],
        [
          "Melhor para",
          "Headshots LinkedIn, fotos de currículo, avatares, masters de documento"
        ],
        [
          "Download",
          "PNG transparente; adicione branco ou azul depois"
        ],
        [
          "Conferir de perto",
          "Cabelo, óculos, brincos, colarinho e ombros"
        ],
        [
          "Não é este artigo",
          "Fundos brancos de produto de marketplace ficam no guia de e-commerce"
        ]
      ],
      "tldrP": "Uma selfie na rua ou um snapshot apressado do escritório ainda pode virar um headshot limpo no Miral AI. Recorte a pessoa uma vez, guarde o arquivo transparente e só então monte a versão branca, azul ou na cor da marca que você realmente precisa.",
      "whatTitle": "O que avatares, fotos de documento e headshots LinkedIn precisam",
      "whatP1": "Os três trabalhos compartilham o mesmo primeiro passo: recortar a pessoa com o Miral AI Background Remover e guardar um PNG transparente limpo. A diferença é a cor e o recorte que você adiciona depois.",
      "whatAvatarP": "O que a remoção de fundo de avatar resolve: selfies de quarto e fotos de rua enterram o rosto na bagunça. Remova o fundo, coloque o recorte em cor da marca ou tom sólido e pré-visualize o recorte circular para Instagram, WeChat ou site pessoal.",
      "galleryAvatarCaption": "Exemplo de avatar: à esquerda, selfie indoor bagunçada; à direita, o recorte em cor sólida pronto para perfil redondo.",
      "whatIdP": "O que a remoção de fundo de documento resolve: pedidos costumam exigir branco ou azul. Um snapshot da sala quase sempre falha. Recorte uma vez, adicione a cor exigida e corte no tamanho oficial. Sempre confira as regras atuais do formulário antes de enviar.",
      "galleryIdCaption": "Exemplo de documento: à esquerda, fundo doméstico agitado; à direita, a mesma pessoa em branco puro para o recorte de tamanho.",
      "whatLinkedInP": "O que o recorte de headshot LinkedIn resolve: escritórios abertos colocam monitores e colegas atrás de você. Um cinza ou branco calmo devolve a atenção ao rosto e à roupa—o primeiro que o recrutador nota.",
      "galleryLinkedInCaption": "Exemplo LinkedIn: à esquerda, selfie de escritório agitado; à direita, o recorte em cinza suave pronto para recrutadores.",
      "whatTipTitle": "Um master transparente para os três",
      "whatTipText": "Baixe primeiro o PNG transparente. Derive o avatar na cor da marca, o export branco/azul de documento e o cartão LinkedIn cinza suave do mesmo arquivo.",
      "howTitle": "Quatro passos até um headshot utilizável",
      "howP": "Abra o Miral AI Background Remover, envie uma foto de ombros para cima, espere a detecção automática e amplie a 100% no cabelo e nos óculos antes de baixar. Só adicione branco ou azul depois que a borda estiver limpa.",
      "howTipTitle": "Prefira o arquivo original",
      "howTipText": "Filtros de beleza pesados e compressão de mensageiros borraram cabelos soltos. O original da câmera quase sempre vence.",
      "edgeTitle": "Onde retratos costumam falhar",
      "edgeCols": [
        "Área",
        "Erro comum",
        "Como conferir"
      ],
      "edgeRows": [
        [
          "Cabelos soltos",
          "Fios apagados como fundo",
          "Ver em telas escura e clara"
        ],
        [
          "Óculos",
          "Haste faltando ou furo na lente",
          "Ampliar os cantos da armação"
        ],
        [
          "Brincos / correntes finas",
          "Linhas de metal quebradas",
          "Seguir a borda da joia"
        ],
        [
          "Linha do colarinho e blazer",
          "Halo branco ou ombro serrilhado",
          "Colocar em tela escura"
        ],
        [
          "Barba ou costeletas",
          "Pelugem suavizada demais",
          "Tentar de novo com menos retoque na fonte"
        ]
      ],
      "edgeP": "“Parece ok” na miniatura não basta. Revisar em tamanho real em duas cores de fundo é o teste de honestidade mais rápido.",
      "useTitle": "Avatar, LinkedIn, currículo e fotos estilo documento",
      "useCols": [
        "Uso",
        "Fundo típico",
        "Nota prática"
      ],
      "useRows": [
        [
          "LinkedIn / sites de emprego",
          "Cinza suave, branco ou blur limpo",
          "Mantenha o rosto nítido; fundos calmos vencem"
        ],
        [
          "Avatar WeChat / Instagram",
          "Cor da marca ou gradiente simples",
          "Pré-visualize o recorte circular antes de postar"
        ],
        [
          "Anexo de currículo",
          "Branco ou cinza claro",
          "Deixe espaço acima da cabeça e abaixo dos ombros"
        ],
        [
          "Impressões estilo documento comuns",
          "Branco ou azul",
          "Adicione a cor no PNG transparente e depois recorte"
        ],
        [
          "Fotos de passaporte / visto",
          "Siga as regras oficiais atuais",
          "Cor, expressão e óculos variam por país"
        ],
        [
          "Capas de curso ou live",
          "Cor da marca ou cena depois",
          "Recorte limpo primeiro, depois desenhe a capa"
        ]
      ],
      "useTipTitle": "As regras mudam",
      "useTipText": "Regras de foto de visto e exame diferem por país e ano. A ferramenta limpa o sujeito; a conformidade ainda vem da checklist oficial.",
      "hairTitle": "Recorte de cabelo e óculos",
      "hairItems": [
        "Fios em contraluz pedem uma foto-fonte mais simples e de alto contraste.",
        "Com óculos, confirme que as duas hastes e a área das lentes ficam intactas.",
        "Cabelo escuro em parede escura é um mau ponto de partida—aproxime-se de uma parede mais clara se puder.",
        "Suéter claro em parede branca costuma perder a borda do ombro; mude o fundo da foto.",
        "Cachos longos e fios de crianças merecem zoom obrigatório a 100% antes do download."
      ],
      "hairP": "Formas grandes de roupa raramente arruínam um recorte de retrato. Cabelo e óculos arruínam. É aí que eu gasto o minuto extra.",
      "troubleTitle": "Quando o headshot parece errado",
      "troubleCols": [
        "Problema",
        "Causa provável",
        "Tente isto"
      ],
      "troubleRows": [
        [
          "Pedacos de cabelo faltando",
          "Fonte suave, comprimida ou em contraluz",
          "Use um original mais nítido com menos beleza"
        ],
        [
          "Borda pálida no rosto ou ombros",
          "Cor do fundo antigo grudada na borda",
          "Confirme em tela escura e tente com mais contraste"
        ],
        [
          "Armação de óculos quebrada",
          "Reflexos fortes confundem o contorno",
          "Refaça a foto com luz mais suave nas lentes"
        ],
        [
          "Roupa se mistura à parede",
          "Baixo contraste sujeito/fundo",
          "Mude o cenário em vez de reenviar o mesmo arquivo"
        ],
        [
          "Foto de documento amarelada",
          "Balanço de branco quente na fonte",
          "Recorte primeiro e neutralize a cor na tela final"
        ]
      ],
      "troubleTipTitle": "Mude a entrada",
      "troubleTipText": "Reenviar a mesma selfie suave raramente corrige o cabelo. Uma fonte mais limpa costuma resolver.",
      "prosConsTitle": "Onde ajuda—e onde você ainda decide",
      "bestTitle": "Hábitos que tornam avatares utilizáveis",
      "bestItems": [
        "Use enquadramento de ombros para cima com um pouco de espaço acima do cabelo.",
        "Mantenha a expressão natural; evite suavização pesada da pele antes do recorte.",
        "Confira o PNG em telas clara e escura toda vez.",
        "Guarde master transparente, export colorido de documento e recorte final em arquivos separados.",
        "Em plataformas de emprego, um fundo calmo deixa rosto e roupa mais legíveis.",
        "Se precisar de clima de café ou escritório depois, recorte limpo primeiro e siga o guia de troca de fundo."
      ],
      "miralTitle": "O que fazer depois do recorte",
      "miralP": "No Miral AI você pode nitidizar o retrato, montar um cartão de avatar calmo ou seguir com Seedream ou FLUX.2 para uma cena de capa. Para troca de fundo de estilo de vida, abra o guia de troca de fundo com IA. Para brancos de listagem de produto, use o guia de e-commerce.",
      "miralLinksTitle": "Próximos passos",
      "intentsTitle": "Fluxos comuns de retrato",
      "faqTitle": "Perguntas antes do upload",
      "faqItems": [
        [
          "Como remover o fundo de um retrato online de graça?",
          "Entre no Miral AI, envie um JPG, PNG ou WebP de ombros para cima e baixe o PNG transparente."
        ],
        [
          "Como fazer uma foto de documento branca ou azul a partir de uma selfie?",
          "Exporte primeiro um PNG transparente, adicione o branco ou azul exigido, recorte no tamanho oficial e confira as regras atuais antes de enviar."
        ],
        [
          "Como fazer um headshot LinkedIn com remoção de fundo?",
          "Remova o fundo agitado do escritório, coloque o recorte em cinza suave ou branco e confirme as bordas de cabelo e ombro antes do upload."
        ],
        [
          "Posso remover o fundo de um avatar WeChat ou Instagram de graça?",
          "Sim. Faça login, processe o original do avatar e pré-visualize o recorte circular na cor da sua marca."
        ],
        [
          "É possível recortar online uma foto com óculos?",
          "Sim, mas amplie a armação, as hastes e a área das lentes antes de baixar."
        ],
        [
          "Qual ferramenta usar para recorte de cabelo em retratos?",
          "Use o Miral AI Background Remover com o original da câmera e confira fios soltos em telas clara e escura."
        ],
        [
          "Qual ferramenta preparar o fundo de uma foto de passaporte?",
          "Crie primeiro um master de retrato transparente e depois exporte a cor oficial e o tamanho em milímetros."
        ],
        [
          "Como corrigir um halo branco após remover o fundo do retrato?",
          "Coloque o PNG transparente em tela escura para achar a borda e tente de novo com um original mais nítido e contrastado."
        ],
        [
          "Como corrigir fios soltos faltando em cachos ou fotos de crianças?",
          "Evite beleza pesada e miniaturas de chat. Use um original mais nítido e revise a 100% antes do download."
        ],
        [
          "Posso processar muitos headshots profissionais de uma vez?",
          "A página atual processa uma imagem por vez para que cada borda de cabelo possa ser revisada."
        ],
        [
          "Qual a diferença entre fundo transparente e branco de documento?",
          "Um PNG transparente pode receber qualquer cor depois. Um export branco de documento já contém pixels brancos para formulários e currículos."
        ],
        [
          "Como mudar o fundo para uma cena de café ou escritório depois?",
          "Depois que o PNG transparente passar na revisão, siga o guia de troca de fundo com IA e confira a combinação de luz."
        ]
      ],
      "miralLinks": [
        {
          "label": "Miral AI Background Remover",
          "path": "/tools/background-remover"
        },
        {
          "label": "Guia de troca de fundo com IA",
          "path": "/hub/articles/ai-background-changer-online"
        },
        {
          "label": "Guia geral de remoção de fundo com IA",
          "path": "/hub/articles/ai-background-remover-online"
        },
        {
          "label": "Guia de fundo de produto e-commerce",
          "path": "/hub/articles/ecommerce-product-background-removal"
        },
        {
          "label": "AI Image Enhancer",
          "path": "/tools/image-enhancer"
        },
        {
          "label": "Seedream 5",
          "path": "/image-models/seedream-ai-image-generator"
        },
        {
          "label": "FLUX.2",
          "path": "/image-models/flux-2-ai-image-generator"
        }
      ]
    },
    "linksTitle": "Continue no Miral AI",
    "linksIntro": "Guarde o master transparente do retrato e depois aprimore, monte um cartão de avatar ou avance para uma cena de estilo de vida.",
    "steps": [
      {
        "title": "Escolha uma foto clara de ombros para cima",
        "text": "Use JPG, PNG ou WebP de até 15 MB com rosto e ombros totalmente visíveis."
      },
      {
        "title": "Remova o fundo automaticamente",
        "text": "O Miral AI Background Remover detecta a pessoa e limpa o fundo inteiro—sem contorno manual."
      },
      {
        "title": "Inspecione cabelo e óculos",
        "text": "Amplie fios soltos, armações, brincos e a linha do colarinho."
      },
      {
        "title": "Baixe o PNG transparente e depois adicione cor",
        "text": "Guarde o master e adicione branco, azul, cinza ou cor da marca para o uso final."
      }
    ],
    "pros": [
      "Feito para bordas de retrato usadas em avatares e fotos estilo documento",
      "Sem ferramenta de caneta do Photoshop para cabelo",
      "Um PNG transparente pode virar muitas cores de fundo",
      "Processamento gratuito no navegador após o login"
    ],
    "cons": [
      "Cabelos finos ainda precisam de checagem em tamanho real",
      "Contraluz ou baixo contraste pode amolecer as bordas",
      "Uma imagem por vez na página atual",
      "Regras oficiais de documento ainda exigem checagem manual de conformidade"
    ],
    "tips": [
      {
        "title": "Confira duas cores de tela",
        "text": "Fundos claros e escuros revelam halos e fios faltando rapidamente."
      },
      {
        "title": "Proteja óculos e joias",
        "text": "Amplie hastes, cantos das lentes e correntes finas antes de baixar."
      },
      {
        "title": "Separe master e export de documento",
        "text": "Não sobrescreva o PNG transparente com um arquivo branco ou azul achatado."
      },
      {
        "title": "Mantenha filtros leves",
        "text": "Beleza pesada amolece exatamente as bordas de que o modelo precisa."
      },
      {
        "title": "Saiba qual guia abrir em seguida",
        "text": "Troca de cena → troca de fundo. Brancos de produto → guia de e-commerce."
      }
    ],
    "scenarios": [
      {
        "title": "Remoção de fundo de headshot LinkedIn",
        "text": "Recorte uma foto nítida de ombros para cima e coloque em cinza suave ou branco antes do upload."
      },
      {
        "title": "Recorte de avatar WeChat ou Instagram",
        "text": "Baixe um PNG transparente e pré-visualize o recorte circular na cor da sua marca."
      },
      {
        "title": "Foto de currículo com fundo branco",
        "text": "Guarde o master transparente e exporte um arquivo branco separado para o PDF."
      },
      {
        "title": "Foto estilo documento com fundo azul",
        "text": "Só adicione o azul exigido depois que a borda do cabelo estiver limpa."
      },
      {
        "title": "Remover fundo ao redor do cabelo online",
        "text": "Use o original da câmera e confira fios soltos em telas clara e escura."
      },
      {
        "title": "Recorte de retrato com óculos",
        "text": "Amplie os cantos da armação e as hastes antes de confiar no download."
      },
      {
        "title": "Preparação de foto de passaporte",
        "text": "Faça o PNG transparente primeiro e siga as regras atuais de tamanho e cor do país."
      },
      {
        "title": "Selfie de escritório para headshot profissional",
        "text": "Remova a bagunça do corredor, mantenha expressão natural e evite filtros pesados."
      },
      {
        "title": "Recorte de crianças ou cabelo cacheado",
        "text": "Espere mais fios soltos; revise sempre a 100% de zoom."
      },
      {
        "title": "Fundo de retrato transparente vs branco",
        "text": "Transparente continua reutilizável; branco é um export achatado para um formulário específico."
      },
      {
        "title": "Corrigir halo branco no recorte do rosto",
        "text": "Confirme a borda em tela escura e tente de novo com mais contraste na fonte."
      },
      {
        "title": "Do recorte de retrato à cena de café",
        "text": "Use o guia de troca de fundo depois que o PNG transparente passar na revisão."
      }
    ],
    "toolFaq": [
      {
        "q": "Como remover o fundo de um retrato online de graça?",
        "a": "Faça login, envie um retrato e baixe o PNG transparente sem instalar software de desktop."
      },
      {
        "q": "Como fazer uma foto de documento branca ou azul a partir de uma selfie?",
        "a": "Remova o fundo, guarde o PNG transparente, adicione a cor exigida e recorte no tamanho oficial."
      },
      {
        "q": "Posso remover o fundo de um avatar WeChat ou Instagram de graça?",
        "a": "Sim. Processe o original do avatar após o login e pré-visualize o recorte circular na cor da marca."
      },
      {
        "q": "É possível recortar online uma foto com óculos?",
        "a": "Sim, mas confira hastes e áreas das lentes em tamanho real antes de baixar."
      },
      {
        "q": "Qual ferramenta usar para recorte de cabelo em retratos?",
        "a": "Use o Miral AI Background Remover com um original nítido e inspecione fios soltos em telas clara e escura."
      },
      {
        "q": "Qual ferramenta preparar o fundo de uma foto de passaporte?",
        "a": "Crie primeiro um master de retrato transparente e exporte a cor e o tamanho oficiais do formulário."
      },
      {
        "q": "Como corrigir um halo branco após remover o fundo do retrato?",
        "a": "Confirme a borda em tela escura e tente de novo com uma fonte mais nítida e contrastada."
      },
      {
        "q": "Como corrigir fios soltos faltando em cachos ou fotos de crianças?",
        "a": "Evite beleza pesada e miniaturas de chat; use um original mais nítido e revise a 100%."
      },
      {
        "q": "Posso processar muitos headshots profissionais de uma vez?",
        "a": "A página atual processa uma imagem por vez."
      },
      {
        "q": "Como mudar o fundo para uma cena de café depois?",
        "a": "Use o PNG transparente revisado com o fluxo de troca de fundo com IA."
      }
    ],
    "links": [
      {
        "label": "Miral AI Background Remover",
        "path": "/tools/background-remover"
      },
      {
        "label": "Guia de troca de fundo com IA",
        "path": "/hub/articles/ai-background-changer-online"
      },
      {
        "label": "Guia geral de remoção de fundo com IA",
        "path": "/hub/articles/ai-background-remover-online"
      },
      {
        "label": "Guia de fundo de produto e-commerce",
        "path": "/hub/articles/ecommerce-product-background-removal"
      },
      {
        "label": "AI Image Enhancer",
        "path": "/tools/image-enhancer"
      },
      {
        "label": "Seedream 5",
        "path": "/image-models/seedream-ai-image-generator"
      },
      {
        "label": "FLUX.2",
        "path": "/image-models/flux-2-ai-image-generator"
      }
    ]
  },
  "changer": {
    "overview": [
      "Trocar o fundo funciona melhor em dois passos: remoção gratuita até um PNG transparente limpo e depois colocação em uma nova cena—luz de café, escritório calmo, parede da marca ou luz do dia externa.",
      "O Miral AI Background Remover cuida do recorte. Seedream ou FLUX.2 podem montar cenas de estilo de vida depois. Não confunda com placas brancas puras estilo Amazon; esse fluxo está no guia de e-commerce.",
      "Se o recorte ainda tiver uma borda pálida, qualquer cena nova parecerá falsa. Conserte as bordas primeiro e só então pense na atmosfera."
    ],
    "practice": [
      "Recuso compor até o sujeito transparente parecer limpo em tela clara e escura.",
      "Alinho a direção da luz antes de alinhar o “bonito”. Um retrato com luz de janela em uma rua neon noturna quase nunca engana."
    ],
    "compareIntro": "Use remoção de fundo para o master transparente, este guia para cenas de estilo de vida ou de capa, o guia de retrato para cores estilo documento e o guia de e-commerce para fundos brancos de marketplace.",
    "workflow": "Recorte o sujeito, escolha uma cena que combine com a iluminação, compose ou gere o novo ambiente e confira sombras de contato, temperatura de cor e bordas antes de exportar.",
    "scenarioIntro": "Defina primeiro o objetivo da cena e mantenha o master transparente separado de cada recorte final.",
    "sec": {
      "tldrTitle": "A ordem que realmente funciona",
      "tldrCols": [
        "Passo",
        "Guardar",
        "Atenção"
      ],
      "tldrRows": [
        [
          "1. Remover fundo",
          "Master PNG transparente do Miral AI",
          "Halos antigos arruínam toda cena posterior"
        ],
        [
          "2. Escolher cena",
          "Café, escritório, parede da marca, outdoor",
          "Escolha pelo trabalho, não por estética aleatória"
        ],
        [
          "3. Compor ou gerar",
          "Imagem lifestyle ou de capa",
          "Combine direção da luz e temperatura de cor"
        ],
        [
          "4. Revisar",
          "Export pronto para publicar",
          "Bordas, escala e sensação de contato"
        ],
        [
          "Separar de placas brancas",
          "Guia de e-commerce para SKUs brancos",
          "Este artigo é para troca de cena"
        ]
      ],
      "tldrP": "Mudar um fundo não é um filtro mágico único. No Miral AI você isola o sujeito com o Background Remover e depois dá a ele um novo lugar para ficar. Pule o primeiro trabalho e o segundo quase sempre parece colado.",
      "removeTitle": "Imagens de estilo de vida, capas sociais e pôsteres de evento precisam de placas diferentes",
      "removeP1": "Cores antigas de parede grudam nas bordas do cabelo e do casaco. O caminho estável é o mesmo: Miral AI Background Remover → master PNG transparente → nova cena para o trabalho. Placas brancas de produto de marketplace ficam no guia de e-commerce, não aqui.",
      "removeLifestyleP": "O que a troca de fundo de estilo de vida resolve: luz de café, lugares na janela e cantos de casa criam atmosfera—mas um fundo original bagunçado deixa o quadro inteiro barato. Recorte limpo e coloque a pessoa em uma cena cuja luz combine com o rosto.",
      "galleryLifestyleCaption": "Exemplo de estilo de vida: à esquerda, o master transparente; à direita, a mesma pessoa composta em uma cena clara de café.",
      "removeSocialP": "O que a troca de fundo de capa social resolve: headers do Instagram, Xiaohongshu e LinkedIn precisam de rosto claro e espaço para título. Quarto bagunçado ou open office enchem o quadro. Um gradiente da marca ou parede de cor calma coloca a pessoa de um lado e deixa o outro para o texto.",
      "gallerySocialCaption": "Exemplo de capa social: à esquerda, o master transparente; à direita, parede com gradiente da marca e espaço para manchete.",
      "removePosterP": "O que a troca de fundo de pôster de evento resolve: webinars, lançamentos de curso e anúncios de palestra precisam de palco calmo ou parede da marca—não uma selfie na mesa. Após o recorte, coloque a pessoa em uma placa suave da marca com espaço para o título e, se precisar, adicione texto no GPT Image.",
      "galleryPosterCaption": "Exemplo de pôster de evento: à esquerda, o master transparente; à direita, parede suave da marca para capa de palestra ou curso.",
      "removeTipTitle": "Mantenha master, cena e recortes de capa separados",
      "removeTipText": "Não sobrescreva o PNG transparente com um único export de café ou gradiente. O pôster da próxima temporada deve reutilizar o mesmo recorte.",
      "howTitle": "Um fluxo online prático",
      "howP": "Abra primeiro o Miral AI Background Remover e obtenha um sujeito transparente confiável. Depois escolha o tipo de fundo: cor sólida é o mais rápido, placa de foto real vem em seguida e ambiente gerado por IA é o mais flexível. Antes de exportar, confira se a pessoa ainda parece iluminada pelo mesmo mundo do fundo.",
      "howTipTitle": "Luz vence decoração",
      "howTipText": "Um fundo mais calmo com luz combinando vence uma cena dramática que luta contra o rosto.",
      "sceneTitle": "Ideias de cena que tendem a clicar",
      "sceneCols": [
        "Direção",
        "Bom para",
        "Atenção"
      ],
      "sceneRows": [
        [
          "Café claro / lugar na janela",
          "Marca pessoal e capas de estilo de vida",
          "Lâmpadas quentes podem deixar a pele laranja demais"
        ],
        [
          "Escritório calmo / blur suave de estante",
          "LinkedIn e imagens de mentor de curso",
          "Adereços do fundo devem ficar mais quietos que o rosto"
        ],
        [
          "Luz do dia externa e vegetação",
          "Posts de viagem, bem-estar e lifestyle",
          "Evite luz dura do meio-dia que lute com o original"
        ],
        [
          "Parede sólida ou gradiente suave da marca",
          "Pôsteres de evento e headers sociais",
          "Mantenha contraste alto o bastante para texto sobreposto"
        ],
        [
          "Iluminação de palco ou keynote",
          "Anúncios de palestra",
          "Flares não devem cortar o rosto"
        ],
        [
          "Canto de estilo de vida em casa",
          "Storytelling suave de produto",
          "Mantenha perspectiva e escala da pessoa consistentes"
        ]
      ],
      "sceneP": "Valer o clique muitas vezes significa claro, não lotado. Uma pessoa limpa em um fundo calmo e intencional costuma superar uma colagem agitada.",
      "qualityTitle": "Cinco lugares onde o falso aparece",
      "qualityItems": [
        "Cabelo e ombros: franjas brancas ou coloridas restantes do cômodo antigo.",
        "Direção da luz: o destaque do rosto e a luz da janela devem concordar.",
        "Temperatura de cor: pele de interior quente em placa azul fria parece dividida.",
        "Escala: a pessoa não deve flutuar como adesivo nem encolher na profundidade errada.",
        "Contato: um toque de contato com chão ou cadeira torna a composição crível."
      ],
      "qualityTipTitle": "Pré-visualize o recorte cedo",
      "qualityTipText": "Confira um recorte quadrado de avatar e um de capa larga antes de fechar a cena final.",
      "vsTitle": "Como este artigo se separa dos outros",
      "vsCols": [
        "Guia",
        "Trabalho principal",
        "Abra quando"
      ],
      "vsRows": [
        [
          "Removedor geral de fundo com IA",
          "Qualquer sujeito → PNG transparente",
          "Você só precisa do recorte"
        ],
        [
          "Fundo de produto e-commerce",
          "Placas brancas / transparentes de produto",
          "Conformidade de listagem Amazon, Shopify"
        ],
        [
          "Removedor de fundo de retrato",
          "Avatares e cores estilo documento",
          "Rostos, cabelo, masters branco/azul de documento"
        ],
        [
          "Troca de fundo com IA (este)",
          "Troca de cena após o recorte",
          "Atmosfera de café, escritório, parede da marca"
        ]
      ],
      "vsP": "Cruze os quatro guias, mas mantenha as palavras-chave honestas. Placas brancas de produto não cabem em artigo de cena de estilo de vida, e fotos de documento azul de visto não cabem em pitch de composição de café.",
      "troubleTitle": "Quando a nova cena parece errada",
      "troubleCols": [
        "Problema",
        "Causa",
        "Correção"
      ],
      "troubleRows": [
        [
          "Franja clara ao redor do sujeito",
          "Recorte ainda sujo",
          "Volte à remoção com original de maior contraste"
        ],
        [
          "Parece adesivo",
          "Falta de contato ou luz desalinhada",
          "Suavize a placa ou adicione sombra de contato bem leve"
        ],
        [
          "Pele fica cinza ou laranja",
          "Choque de temperatura de cor",
          "Escolha cena de temperatura mais próxima ou unifique a grade"
        ],
        [
          "Cabelo parece sujo",
          "Alpha incompleto ao redor dos fios",
          "Limpe o recorte antes de compor de novo"
        ],
        [
          "Forma do produto muda em cena de IA",
          "A geração alterou o objeto",
          "Trave a identidade; deixe a IA inventar só o ambiente"
        ]
      ],
      "prosConsTitle": "O que este fluxo libera",
      "bestTitle": "Trocas que aguentam a tela do celular",
      "bestItems": [
        "Nunca pule o master transparente limpo.",
        "O canal decide a cena: contratação fica calma, lifestyle pode respirar, pôsteres precisam de espaço para título.",
        "Iluminação de fonte simples facilita a troca.",
        "Sempre pré-visualize em tamanho de celular antes de postar.",
        "Adicione texto de manchete depois que a cena funcionar—GPT Image ajuda com tipografia de pôster.",
        "Envie SKUs brancos de marketplace ao guia de e-commerce para manter as intenções separadas."
      ],
      "miralTitle": "Mantenha a cadeia dentro do Miral AI",
      "miralP": "Caminho sugerido no Miral AI: Background Remover → Image Enhancer opcional → Seedream ou FLUX.2 para o ambiente → GPT Image se precisar de tipografia de pôster. Para cartões branco ou azul estilo documento, volte ao guia de retrato.",
      "miralLinksTitle": "Próximos passos",
      "intentsTitle": "Trabalhos comuns de troca de fundo",
      "faqTitle": "Perguntas práticas",
      "faqItems": [
        [
          "Como mudar o fundo de uma foto online de graça?",
          "Entre no Miral AI, exporte um PNG transparente com o Background Remover e coloque o sujeito em um café, parede da marca ou nova cena."
        ],
        [
          "Como fazer uma imagem de estilo de vida a partir de um PNG transparente?",
          "Compose em uma placa com luz combinando, confira contato e temperatura de cor e mantenha master e recortes de capa separados."
        ],
        [
          "Como mudar o fundo de uma capa social após o recorte?",
          "Depois que as bordas do cabelo passarem na revisão, coloque o sujeito de um lado de um gradiente da marca e deixe espaço para o título."
        ],
        [
          "Posso trocar o fundo de uma selfie por uma cena de café?",
          "Sim. Recorte limpo primeiro e compose em uma placa de café cuja luz de janela combine com o rosto."
        ],
        [
          "É possível gerar uma nova cena de IA atrás de uma pessoa real?",
          "Sim. Mantenha o sujeito real do PNG transparente e deixe Seedream ou FLUX.2 inventar só o ambiente."
        ],
        [
          "Qual ferramenta usar para troca de fundo de pôster de evento?",
          "Use o Miral AI Background Remover para o recorte, coloque em uma parede suave da marca e adicione tipografia de manchete no GPT Image se precisar."
        ],
        [
          "Qual ferramenta usar para troca de fundo de capa social?",
          "Background Remover mais parede na cor da marca ou gradiente. Continue no Seedream ou FLUX.2 quando precisar de uma cena de estilo de vida mais completa."
        ],
        [
          "Como corrigir uma composição de fundo que parece falsa?",
          "Inspecione franja, direção da luz e temperatura de cor nessa ordem. Se as bordas estiverem sujas, volte primeiro à remoção de fundo."
        ],
        [
          "Como corrigir desalinhamento de luz do dia externa ao trocar fundos?",
          "Combine a direção do sol; evite luz dura do meio-dia em um rosto iluminado para interior."
        ],
        [
          "Posso usar troca de fundo em uma capa de vídeo?",
          "Sim. Exporte o recorte na proporção da capa e mantenha o sujeito na área segura."
        ],
        [
          "Qual a diferença entre remoção e troca de fundo?",
          "Remoção entrega um sujeito transparente. Troca coloca esse sujeito em uma nova cena ou cor."
        ],
        [
          "Posso usar isto para fundos brancos de produto da Amazon?",
          "Não. Placas brancas de marketplace ficam no guia de e-commerce; este artigo é para cenas de estilo de vida e de capa."
        ]
      ],
      "miralLinks": [
        {
          "label": "Miral AI Background Remover",
          "path": "/tools/background-remover"
        },
        {
          "label": "Guia de retrato e documento",
          "path": "/hub/articles/ai-portrait-background-remover"
        },
        {
          "label": "Guia geral de remoção de fundo com IA",
          "path": "/hub/articles/ai-background-remover-online"
        },
        {
          "label": "Guia de fundo de produto e-commerce",
          "path": "/hub/articles/ecommerce-product-background-removal"
        },
        {
          "label": "AI Image Enhancer",
          "path": "/tools/image-enhancer"
        },
        {
          "label": "Seedream 5",
          "path": "/image-models/seedream-ai-image-generator"
        },
        {
          "label": "FLUX.2",
          "path": "/image-models/flux-2-ai-image-generator"
        },
        {
          "label": "GPT Image 1.5",
          "path": "/image-models/gpt-image-ai-image-generator"
        }
      ]
    },
    "linksTitle": "Monte o fluxo de cena no Miral AI",
    "linksIntro": "Recorte uma vez, guarde o master transparente e crie cenas de estilo de vida, capas ou placas de pôster sem refazer a máscara.",
    "steps": [
      {
        "title": "Recorte primeiro um sujeito limpo",
        "text": "Use o Miral AI Background Remover para baixar um PNG transparente e confirmar bordas de cabelo ou produto."
      },
      {
        "title": "Decida o clima da nova cena",
        "text": "Café, escritório calmo, luz do dia externa ou parede da marca—escolha pelo canal."
      },
      {
        "title": "Coloque o sujeito no novo fundo",
        "text": "Compose na tela de design ou continue no Seedream / FLUX.2 com luz combinando."
      },
      {
        "title": "Confira luz, escala e contato",
        "text": "Procure franjas, choque de cor, tamanho errado e falta de contato."
      },
      {
        "title": "Exporte o recorte de que precisa",
        "text": "Salve tamanhos de capa e avatar separadamente e mantenha o master transparente intacto."
      }
    ],
    "pros": [
      "Um master transparente sustenta muitas cenas",
      "Mais barato do que refotografar cada ambiente",
      "Forte encaixe para capas sociais e frames lifestyle",
      "Conecta bem ao trabalho de cena com Seedream e FLUX.2"
    ],
    "cons": [
      "Luz desalinhada parece falsa na hora",
      "Bordas de recorte sujas estragam a composição inteira",
      "SKUs brancos de marketplace devem usar o guia de e-commerce",
      "Cenas de perspectiva complexa ainda podem precisar de retoque manual"
    ],
    "tips": [
      {
        "title": "Bordas antes da atmosfera",
        "text": "Nunca compose um recorte que ainda mostre halo em tela escura."
      },
      {
        "title": "Combine a luz primeiro",
        "text": "Escolha placas cuja luz principal concorde com o rosto ou o produto."
      },
      {
        "title": "Mantenha masters separados",
        "text": "PNG transparente, export lifestyle e recortes sociais devem ser arquivos diferentes."
      },
      {
        "title": "Deixe espaço para texto",
        "text": "Fundos de pôster precisam de zonas mais calmas onde a manchete possa sentar."
      },
      {
        "title": "Separe intenções de busca",
        "text": "Envie placas brancas da Amazon ao artigo de e-commerce; mantenha este para troca de cena."
      }
    ],
    "scenarios": [
      {
        "title": "Trocar fundo de foto online de graça",
        "text": "Recorte o sujeito primeiro e coloque em uma nova placa ou cena gerada."
      },
      {
        "title": "Fundo lifestyle de café para retrato",
        "text": "Use uma placa com luz de janela que combine com a iluminação do rosto."
      },
      {
        "title": "Fundo de escritório para foto profissional",
        "text": "Mantenha prateleiras e adereços mais suaves que a pessoa."
      },
      {
        "title": "Fundo na cor da marca para capa social",
        "text": "PNG transparente em sólido ou gradiente suave com espaço para o título."
      },
      {
        "title": "Mudar fundo após recorte com IA",
        "text": "Não compose até bordas de cabelo e casaco passarem na checagem das duas telas."
      },
      {
        "title": "Cena gerada por IA atrás de pessoa real",
        "text": "Deixe Seedream ou FLUX.2 inventar o cômodo, não um novo rosto ou roupa."
      },
      {
        "title": "Troca de fundo de pôster de evento",
        "text": "Prefira paredes limpas da marca para a tipografia da manchete continuar legível."
      },
      {
        "title": "Troca de fundo com luz do dia externa",
        "text": "Combine a direção do sol; evite luz do meio-dia em rosto suave de interior."
      },
      {
        "title": "Corrigir composição de fundo que parece falsa",
        "text": "Inspecione franja, direção da luz e temperatura de cor nessa ordem."
      },
      {
        "title": "Do PNG transparente à imagem de estilo de vida",
        "text": "Arquive o master e exporte recortes de capa separadamente."
      },
      {
        "title": "Não é para fundos brancos da Amazon",
        "text": "Envie placas de listagem ao guia de produto e-commerce."
      },
      {
        "title": "Recorte de retrato e depois troca de cena",
        "text": "Termine a revisão do cabelo no fluxo de retrato e abra este fluxo de cena."
      }
    ],
    "toolFaq": [
      {
        "q": "Como mudar o fundo de uma foto online de graça?",
        "a": "Faça login, remova o fundo original para um PNG transparente e coloque o sujeito em uma nova cena ou cor sólida."
      },
      {
        "q": "Como fazer uma imagem de estilo de vida a partir de um PNG transparente?",
        "a": "Compose em uma placa com luz combinando, confira contato e temperatura de cor e separe o master dos recortes de capa."
      },
      {
        "q": "Posso trocar o fundo de uma selfie por uma cena de café?",
        "a": "Sim. Recorte a pessoa primeiro e compose em uma placa de café com luz de janela semelhante."
      },
      {
        "q": "É possível gerar uma nova cena de IA atrás de uma pessoa real?",
        "a": "Sim. Mantenha o sujeito real e deixe Seedream ou FLUX.2 criar só o ambiente."
      },
      {
        "q": "Qual ferramenta usar para troca de fundo de pôster de evento?",
        "a": "Use o Background Remover para o recorte, coloque em uma parede calma da marca e adicione tipografia de manchete se precisar."
      },
      {
        "q": "Qual ferramenta usar para troca de fundo de capa social?",
        "a": "Background Remover mais parede na cor da marca ou gradiente; continue no Seedream ou FLUX.2 para cenas de estilo de vida mais completas."
      },
      {
        "q": "Como corrigir uma composição de fundo que parece falsa?",
        "a": "Limpe a franja, combine a direção da luz e unifique a temperatura de cor antes de exportar."
      },
      {
        "q": "Como corrigir desalinhamento de luz do dia externa ao trocar fundos?",
        "a": "Combine a direção do sol e evite luz do meio-dia em rosto iluminado para interior."
      },
      {
        "q": "Posso usar troca de fundo em uma capa de vídeo?",
        "a": "Sim. Exporte o recorte na proporção da capa e mantenha o sujeito na área segura."
      },
      {
        "q": "Posso usar isto para fundos brancos de produto da Amazon?",
        "a": "Não. Use o guia de fundo de produto e-commerce para placas brancas de marketplace."
      }
    ],
    "links": [
      {
        "label": "Miral AI Background Remover",
        "path": "/tools/background-remover"
      },
      {
        "label": "Guia de retrato e documento",
        "path": "/hub/articles/ai-portrait-background-remover"
      },
      {
        "label": "Guia geral de remoção de fundo com IA",
        "path": "/hub/articles/ai-background-remover-online"
      },
      {
        "label": "Guia de fundo de produto e-commerce",
        "path": "/hub/articles/ecommerce-product-background-removal"
      },
      {
        "label": "AI Image Enhancer",
        "path": "/tools/image-enhancer"
      },
      {
        "label": "Seedream 5",
        "path": "/image-models/seedream-ai-image-generator"
      },
      {
        "label": "FLUX.2",
        "path": "/image-models/flux-2-ai-image-generator"
      },
      {
        "label": "GPT Image 1.5",
        "path": "/image-models/gpt-image-ai-image-generator"
      }
    ]
  },
  "articles": {
    "ai-portrait-background-remover": {
      "title": "Removedor de fundo de retrato com IA grátis: headshots, avatares e fotos de documento",
      "excerpt": "Transforme uma selfie bagunçada em um headshot limpo: remova o fundo do retrato de graça, exporte um PNG transparente e adicione branco, azul ou cor da marca para LinkedIn, currículos e avatares.",
      "metaTitle": "Removedor de fundo de retrato com IA grátis | Miral",
      "metaDescription": "Remova fundos de retrato de graça com o Miral AI. Preserve detalhes do cabelo, exporte recortes PNG transparentes e monte headshots LinkedIn ou fotos estilo documento brancas e azuis.",
      "target": {
        "label": "Abrir removedor de fundo de retrato",
        "path": "/tools/background-remover"
      },
      "keywords": [
        "remover fundo de retrato grátis",
        "remover fundo headshot IA",
        "remover fundo foto LinkedIn",
        "remover fundo foto documento",
        "remover fundo avatar",
        "remover fundo ao redor do cabelo",
        "foto currículo fundo branco",
        "foto documento fundo azul online"
      ]
    },
    "ai-background-changer-online": {
      "title": "Trocador de fundo com IA grátis: estilo de vida, capas sociais e pôsteres de evento",
      "excerpt": "Remova o fundo antigo de graça e coloque pessoas em cenas de estilo de vida de café, capas sociais com gradiente da marca ou paredes de pôster de evento—sem competir com a intenção de fundo branco de e-commerce.",
      "metaTitle": "Trocador de fundo com IA online grátis | Miral",
      "metaDescription": "Mude fundos de fotos online com o Miral AI: recorte para PNG transparente e monte imagens de estilo de vida de café, capas sociais e cenas de pôster de evento.",
      "target": {
        "label": "Abrir removedor de fundo com IA",
        "path": "/tools/background-remover"
      },
      "keywords": [
        "trocador de fundo IA grátis",
        "trocar fundo de foto online",
        "mudar fundo após recorte",
        "troca de cena com IA",
        "trocador de fundo de estilo de vida",
        "fundo de café para retrato",
        "trocar fundo capa social",
        "PNG transparente novo fundo"
      ]
    }
  }
}
